import { PropsWithChildren, JSX } from 'react';
import classNames from 'classnames';
import { CustomCssClassNames } from '@bg-shared';
import classes from './PanelHeader.module.scss';

interface IProps {
    className?: string;
}

export const PanelHeader = (props: PropsWithChildren<IProps>): JSX.Element => (
    <header
        className={classNames(
            classes.panelHeader,
            CustomCssClassNames.PANEL_HEADER,
            props.className,
        )}
    >
        {props.children}
    </header>
);
